export default __webpack_public_path__ + "static/media/docker.c2c005ba.svg";